<script module lang="ts">
  import type { IslandProps } from "~/types/islands";

  export interface Props extends IslandProps {
    name?: "plp" | "search";
    accountId?: string;
    domainKey?: string;
    rows?: number;
    collectionKey?: string;
    collectionCount?: number;
    collectionTitle?: string;
    collectionDescription?: string;
    collectionUrl?: string;
    shopUrl?: string;
  }
</script>

<script lang="ts">
  import { QueryClientProvider } from "@tanstack/svelte-query";
  import PlpPage from "./plp/PlpPage.svelte";
  import SearchPage from "./search/SearchPage.svelte";
  import Theme from "~/components/Theme.svelte";

  let {
    name,
    queryClient,
    accountId,
    domainKey,
    rows,
    collectionKey,
    collectionCount,
    collectionTitle,
    collectionDescription,
    collectionUrl,
    shopUrl,
  }: Props = $props();

  const isDev = import.meta.env.DEV;

  type DevtoolsComponent =
    (typeof import("@tanstack/svelte-query-devtools"))["SvelteQueryDevtools"];
  let Devtools = $state<DevtoolsComponent | null>(null);

  if (isDev) {
    import("@tanstack/svelte-query-devtools").then((mod) => {
      Devtools = mod.SvelteQueryDevtools;
    });
  }
</script>

<QueryClientProvider client={queryClient}>
  <Theme>
    {#if name === "plp"}
      <PlpPage
        {accountId}
        {domainKey}
        {collectionKey}
        {rows}
        {collectionCount}
        {collectionTitle}
        {collectionDescription}
        {collectionUrl}
        {shopUrl}
      />
    {:else if name === "search"}
      <SearchPage {accountId} {domainKey} {rows} />
    {:else}
      <p role="alert">Unrecognized island name: "{name}"</p>
    {/if}
  </Theme>
  {#if isDev && Devtools}
    <Devtools />
  {/if}
</QueryClientProvider>
